import { pipe } from 'fp-ts/lib/function';
import * as t from 'io-ts';
import * as Either from 'fp-ts/Either';
import isValidDate from 'date-fns/isValid';
import addHours from 'date-fns/addHours';
import differenceInHours from 'date-fns/differenceInHours';

/**
 * Converts a number of hours since the start of Unix epoch to a Date.
 */
export const DateFromUnixHours = new t.Type<Date, number, unknown>(
  'DateFromUnixHours',
  (u): u is Date => u instanceof Date,
  (u, c) => {
    return pipe(
      t.number.validate(u, c),
      Either.map((unixDays) => addHours(new Date(0), unixDays)),
      Either.chain((date) => (isValidDate(date) ? t.success(date) : t.failure(u, c)))
    );
  },
  (date) => differenceInHours(date, new Date(0))
);
